export const Role = {
    Admin: 1,
    Staff: 2,
    User: 2
}